import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

import template from './store-column.pug';

export class StoreColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    super({
      name: 'Store',
      property: 'StoreName',
      title: newI18n.getString(_TL_('Store')),
      bodyClasses: ['grid-column-storeName', 'actionable'],
      colClasses: ['col-longText'],
      type: 'string',
      helpId: 'pop_BA_Reporting_Store',
    });
    this.i18n = i18n;
  }

  template({
    value: {
      StoreName,
    },
  }) {
    return template({ StoreName: _.isEmpty(StoreName) ? '--' : StoreName });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
